import script from "./Geography-item.vue?vue&type=script&setup=true&lang=js"
export * from "./Geography-item.vue?vue&type=script&setup=true&lang=js"

import "./Geography-item.vue?vue&type=style&index=0&id=ff8e2974&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff8e2974"]])

export default __exports__